import { tzAxios } from 'api/axios';
import { HistoryResponse } from 'api/responseTypes';
import { withAuthHeader } from 'api/utils/authenticatedRequest';

export const getHistoryOrdersInfo = async (token: string) =>
  (await tzAxios.get<HistoryResponse>('/ticket-zone/ticket-orders', withAuthHeader(token))).data;
